var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0171 11.2714L14.7885 7.5M14.7885 7.5L11.0171 3.7286M14.7885 7.5H5.7371M7.99994 11.2714C7.99994 11.4943 7.99994 11.6058 7.99166 11.7024C7.90552 12.706 7.16635 13.5319 6.17838 13.7283C6.08334 13.7472 5.97245 13.7595 5.75095 13.7841L4.98052 13.8697C3.8231 13.9983 3.24437 14.0626 2.7846 13.9155C2.17157 13.7193 1.6711 13.2714 1.40843 12.6838C1.21143 12.2431 1.21143 11.6608 1.21143 10.4962V4.50377C1.21143 3.33922 1.21143 2.75694 1.40843 2.31623C1.6711 1.72861 2.17157 1.28067 2.7846 1.08449C3.24437 0.937367 3.82309 1.00167 4.98052 1.13027L5.75094 1.21588C5.97253 1.2405 6.08332 1.25281 6.17838 1.27171C7.16635 1.46814 7.90552 2.29399 7.99166 3.29761C7.99994 3.39418 7.99994 3.50565 7.99994 3.7286",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.cf6695a123852c1cc8f932a926797911.svg";
export { ForwardRef as ReactComponent };